//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import {makeStyles} from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import {red} from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import clsx from 'clsx';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Tooltip from "@material-ui/core/Tooltip";
//import DeleteIcon from "@material-ui/core/SvgIcon/SvgIcon";
import DeleteIcon from '@material-ui/icons/Delete';

import EditIcon from '@material-ui/icons/Edit';



/* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 1,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 2,
    },
    card: {
        maxWidth: 1200,
        backgroundColor:'#faf7ff',
        borderWidth:0,
        borderColor:'black',
        marginBottom:'1px',
        elevation:10,
        square:true
    },

    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },

});


//'url(' + require('../../images/IMG_1.JPG')
class CardExpandableRecord extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            age: '',
            name: 'Farshid',
            testnumber: '1232322',
            labelWidth: 0,
            open:false,
            expanded:false,
        };
        //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
        this.deleteImageClick = this.deleteImageClick.bind(this);
        this.editImageClick = this.editImageClick.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.PaperComponent = this.PaperComponent.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);


    }


    deleteImageClick(argData){

        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });


    }

    editImageClick(argData){
        //alert('edit was  1 called');
        /*const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
        if(argData.editMode){
            if(argData.editMode == true) {

                argData.editMode = false;
            }else{
                argData.editMode = true;
            }
        }else{
            argData.editMode = true;
        }
        */

        this.props.onEdit(argData);
    }

    handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };

    handleDelete(){
        this.props.onDelete(this.props.info.id);
        this.setState({ open: false });
    };

    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
    }


    handleExpandClick() {
        //setExpanded(!expanded);

        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        const {classes} = this.props;
        // const classes2 = useStyles();

        return (
            <Card className={classes.card}>
            {/* I don't see a use for this part }
            <CardHeader >
            <Grid container spacing={24}>

            <Grid item xs={2} sm={2}>
            <CreditCardIcon fontSize="large" color="primary"></CreditCardIcon>

            </Grid>
            <Grid item xs={10} sm={10}>
            <div>
            < Typography  style={{display: 'inline-block'}}
        variant = "h6" >
            Credit card 5information
        < /Typography>
        </div>
        </Grid>
        </Grid>
            </CardHeader>
            */}

            <CardContent>




            <Grid container spacing={24}>

            <Grid item xs={2} sm={2}>
            <CreditCardIcon fontSize="large" color="primary"></CreditCardIcon>

            </Grid>
            <Grid item xs={10} sm={10}>
            <div>
            < Typography  style={{display: 'inline-block'}}
        variant = "body2" >
            Credit card456 6information {this.props.info.name}
        < /Typography>
        </div>
        </Grid>
            </Grid>







        </CardContent>
        <CardActions >

        <Tooltip title="Edit" aria-label="Edit">
            <IconButton  color="primary" aria-label="edit" className={classes.margin}>
            <EditIcon fontSize="large" onClick={() =>this.editImageClick(this.props.info)}/>
        </IconButton>
        </Tooltip>





            <IconButton
        className={clsx(classes.expand, {
            [classes.expandOpen]: this.state.expanded,
        })}
        onClick={this.handleExpandClick}
        aria-expanded={this.state.expanded}
        aria-label="show more"
        >
        <ExpandMoreIcon />
        </IconButton>
        </CardActions>



        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
        < CardContent >
        <Grid container spacing={24}>

    <Grid item xs={6} sm={6}>
            < Typography   style={{display: 'inline-block'}}
        variant="button"
            >

            Name:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1"
            >
            {this.props.info.name}
            < /Typography>
            </Grid>


            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button"
            >
            Number:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1"
            >
            {this.props.info.number}
            < /Typography>
            </Grid>

            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            Address:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1" >
            {this.props.info.address1}  {this.props.info.address2}
    < /Typography>
        </Grid>


        <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            City:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1" >
            {this.props.info.city}
            < /Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            State:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block', marginLeft: 15}}
        variant = "body1" >
            {this.props.info.state}
            < /Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            Country:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1" >
            {this.props.info.country}
            < /Typography>
            </Grid>

            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            ZIpCode:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1" >
            {this.props.info.zipcode}
            < /Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            Phone:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block' , marginLeft: 15}}
        variant = "body1" >
            {this.props.info.phone}
            < /Typography>
            </Grid>

            <Grid item xs={6} sm={6}>
            < Typography  style={{display: 'inline-block'}}
        variant = "button" >
            CVV:
    < /Typography>
        <br/>
        < Typography  style={{display: 'inline-block', marginLeft: 15 }}
        variant = "body1" >
            {this.props.info.securityCode}
            < /Typography>
            </Grid>




            </Grid>
            < /CardContent>
        </Collapse>
        </Card>
    );
    }//end of render
}//End of class

CardExpandableRecord.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardExpandableRecord);